import { render } from "./Details.vue?vue&type=template&id=09b6d8ce"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=09b6d8ce&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.11.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__